<!-- TEMPLATE -->
<template>
  <div :class='addressDetailsClass'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          v-if="canSaveCustomerAddress()"
          :icon='saveIcon'
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="processAddress"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-select-form-row placeholder="Kies een context" id='addressContext' label='Soort adres'
                              :options='addressContextList' :value='currentAddressType'
                              @input='addressTypeFieldChanged' :required-field="true"
                              :disabled="! canSaveCustomerAddress()"
                              :warning="$v.data.addressContext.$error"
                              @focus="$v.data.addressContext.$touch()"></dean-select-form-row>
        <dean-form-row id="attention" v-model="addressData.attention" label="T.a.v."
                       :disabled="! canSaveCustomerAddress()"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="street" v-model="addressData.street" label="Straat" @input="inputFieldChanged"
                       :required-field="true"
                       :disabled="! canSaveCustomerAddress()"
                       :warning="$v.data.street.$error"
                       @focus="$v.data.street.$touch()"></dean-form-row>
        <dean-form-row id="houseNumber" v-model="addressData.houseNumber" label="Huisnummer"
                       @input="inputFieldChanged" :required-field="true"
                       :disabled="! canSaveCustomerAddress()"
                       :warning="$v.data.houseNumber.$error"
                       @focus="$v.data.houseNumber.$touch()"></dean-form-row>
        <dean-form-row id="houseNumber" v-model="addressData.houseNumberExtension" label="Toevoeging huisnummer"
                       @input="inputFieldChanged"
                       :disabled="! canSaveCustomerAddress()"
                       :warning="$v.data.houseNumberExtension.$error"
                       @focus="$v.data.houseNumberExtension.$touch()"></dean-form-row>
        <dean-form-row id="postalCode" v-model="addressData.postalCode" label="Postcode" @input="inputFieldChanged"
                       :required-field="true"
                       :disabled="! canSaveCustomerAddress()"
                       :warning="$v.data.postalCode.$error"
                       @focus="$v.data.postalCode.$touch()"></dean-form-row>
        <dean-form-row id="city" v-model="addressData.city" label="Plaats" @input="inputFieldChanged"
                       :required-field="true"
                       :disabled="! canSaveCustomerAddress()"
                       :warning="$v.data.city.$error"
                       @focus="$v.data.city.$touch()"></dean-form-row>
      </div>
      <div class="column" slot="right">

      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue} from 'vue-property-decorator';
  import vSelect from 'vue-select';
  import axios from 'axios';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import {postalCode} from '@/mixins/validators';
  import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';

  import {
    businessIcon,
    commissionIcon,
    customerIcon,
    customerServiceIcon,
    deanAlertDialog,
    deanIcon,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    invoicesIcon,
    messageIcon,
    offersIcon,
    ordersIcon,
    returnIcon,
    saveIcon,
    summeryIcon,
    usersIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {validationMixin} from 'vuelidate';
  import {mixins} from 'vue-class-component';

  @Component({
    components: {
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      deanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      vSelect,
      invoicesIcon,
      deanIcon,
      returnIcon,
      saveIcon,
      summeryIcon,
      customerIcon,
      businessIcon,
      usersIcon,
      offersIcon,
      ordersIcon,
      commissionIcon,
      customerServiceIcon,
      messageIcon,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuCustomerMixin) {

    public returnIcon: object = returnIcon;
    public saveIcon: object = saveIcon;
    public showSomething: boolean = false;
    public timeout?: number;
    public data: {
      id: string|null,
      personId: any,
      addressContext: any,
      attention: any,
      street: any,
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      city: any,
    } = {
      id: null,
      personId: null,
      addressContext: null,
      attention: null,
      street: null,
      houseNumber: null,
      houseNumberExtension: null,
      postalCode: null,
      city: null,
    };

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          addressContext: {required},
          street: {required},
          houseNumber: {required},
          houseNumberExtension: {},
          postalCode: {required, postalCode},
          city: {required},
        },
      };
    }

    get addressDetailsClass() {
      let value = 'customer-add';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get addressData(): {
      id: string|null,
      addressContext: any,
      attention: any,
      street: any,
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      city: any,
    } {
      return this.data;
    }

    get addressContextList() {
      return [
        {value: 'main', label: 'Bezoekadres'},
        {value: 'postal', label: 'Postadres'},
        {value: 'invoice', label: 'Factuuradres'},
        {value: 'product', label: 'Aansluitadres'},
        {value: 'delivery', label: 'Bezorgadres'},
      ];
    }

    get currentAddressType() {
      const addressContexts = this.addressContextList;
      const currentAddressType = this.addressData.addressContext;
      if (currentAddressType !== null) {
        const foundKey: any = Object.keys(addressContexts).find((key) =>
          // @ts-ignore-next-line
          addressContexts[key].value === currentAddressType);
        return foundKey != null ? addressContexts[foundKey] : null;
      }
      return null;
    }

    get headerTitle(): string {
      return (this.$route.params.id !== undefined) ? 'Adres wijzigen' : 'Adres toevoegen';
    }

    public inputFieldChanged(field: any) {
      const name: string = field.id;
      // @ts-ignore-next-line
      this.data[name] = field.value;
    }

    public addressTypeFieldChanged(field: any) {
      this.data.addressContext = field.value;
    }

    public addressDetails() {
      this.data.personId = this.$route.params.pid;

      if (this.$route.params.addressId) {
        this.$store.dispatch('setLoadOverlay', true);
        const url = '/-/trade/api/customer.address.info';

        axios.post(url, {
          id: this.$route.params.addressId,
        }).then(
          (response) => {
            this.data = response.data;
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => this.$store.dispatch('setLoadOverlay', false));
      }
    }

    public created() {
      this.addressDetails();
      this.buildSideMenuCustomer(this.$route.params.pid);
    }

    public processAddress() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        const url = '/-/trade/api/customer.address.save';

        axios.post(url, this.addressData).then(
          (response) => {
            this.$toast({
              icon: saveIcon,
              text: 'Adres opgeslagen',
              theme: 'success',
            });
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        ).finally(() => this.$store.dispatch('setLoadOverlay', false));
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public canSaveCustomerAddress(): boolean {
      if (
          this.addressData?.id
          && this.$store.getters.getUser.privileges.includes('update-customer-address')
      ) {
        return true;
      }

      if (
          this.addressData?.id === null
          && this.$store.getters.getUser.privileges.includes('create-customer-address')
      ) {
        return true;
      }

      return false;
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
